import { v4 } from "uuid";
// Create an anonymous user GUID
// This function is required for old dodgy webviews that don't have 
// crypto.randomUUID() or non-HTTPS websites.
export const createAnonymousUserGuid = () => {
    try {
        return crypto.randomUUID();
    }
    catch {
        return v4();
    }
}
//Create and store a GUID used to identify anonymous users between sessions.
export const getSentryAnonymousUserGuid = () => {
    try {
        // Retrieve stored GUID.
        const storedUserId = localStorage.getItem("sentry-user-id");
        if (storedUserId) {
            // return stored GUID
            return storedUserId;
        }
        // Create new GUID as no stored GUID exsits.
        const userId = createAnonymousUserGuid();
        // Store new GUID
        localStorage.setItem("sentry-user-id", userId);
        // Return new GUID.
        return userId;
    }
    catch {
        // Local Storage can be disabled or limited by the users browser
        // settings. If local storage is not accessible the above will
        // error and a new GUID will be returned. For these users they will
        // only be able to be identified until they refresh the page.
        return createAnonymousUserGuid();
    }
}
// Function to return the Anonymous user data.
export const createSentryAnonymousUser = () => {
    const userGuid = getSentryAnonymousUserGuid();
    return {
        id: `Anonymous - ${userGuid}`,
        username: `Anonymous - ${userGuid}`,
        fullName: 'Anonymous User'
    }
}